import React from 'react';
import { Card } from '../../components/ui/Card';
import { TabNavigation } from '../../components/operations/TabNavigation';
import { ChevronDown, TrendingUp, TrendingDown, AlertTriangle, Sparkles } from 'lucide-react';
const MENU_TABS = [{
  label: 'Products',
  path: ''
}, {
  label: 'Categories',
  path: 'categories'
}, {
  label: 'Modifiers',
  path: 'modifiers'
}, {
  label: 'Combos',
  path: 'combos'
}, {
  label: 'Stock',
  path: 'stock'
}, {
  label: 'Promotions',
  path: 'promotions'
}, {
  label: 'Performance',
  path: 'performance'
}];
const CATEGORY_STATS = [{
  name: '🍔 Burgeri',
  sold: '1,247',
  revenue: '2.4M RSD',
  margin: 71.5,
  trend: '+8%'
}, {
  name: '🥞 Palačinke',
  sold: '689',
  revenue: '890K RSD',
  margin: 80.4,
  trend: '+5%'
}, {
  name: '🍟 Sides',
  sold: '1,102',
  revenue: '1.8M RSD',
  margin: 74.6,
  trend: '+12%'
}, {
  name: '🥤 Drinks',
  sold: '543',
  revenue: '580K RSD',
  margin: 65.0,
  trend: '+3%',
  warning: true
}, {
  name: '🥗 Salate',
  sold: '156',
  revenue: '320K RSD',
  margin: 69.2,
  trend: '-2%'
}, {
  name: '🌯 Giros',
  sold: '89',
  revenue: '210K RSD',
  margin: 67.0,
  trend: '-5%',
  warning: true
}];
export function Performance() {
  return <div className="space-y-6 animate-in fade-in duration-500" data-id="element-1345">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4" data-id="element-1346">
        <h1 className="text-2xl font-bold text-text-primary" data-id="element-1347">
          Menu Performance
        </h1>
        <div className="flex items-center gap-3" data-id="element-1348">
          <button className="flex items-center gap-2 px-3 py-2 bg-background-elevated rounded-lg text-sm font-medium hover:bg-white/5 transition-colors" data-id="element-1349">
            Last 7 Days <ChevronDown size={14} data-id="element-1350" />
          </button>
          <button className="flex items-center gap-2 px-3 py-2 bg-background-elevated rounded-lg text-sm font-medium hover:bg-white/5 transition-colors" data-id="element-1351">
            All Locations <ChevronDown size={14} data-id="element-1352" />
          </button>
        </div>
      </div>

      <TabNavigation tabs={MENU_TABS} basePath="/menu" data-id="element-1353" />

      {/* Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-1354">
        <Card className="p-4" data-id="element-1355">
          <div className="text-sm text-text-secondary mb-1" data-id="element-1356">Total Revenue</div>
          <div className="text-2xl font-bold mb-1" data-id="element-1357">5.84M RSD</div>
          <div className="text-xs text-accent-success" data-id="element-1358">+8% vs LW</div>
        </Card>
        <Card className="p-4" data-id="element-1359">
          <div className="text-sm text-text-secondary mb-1" data-id="element-1360">Items Sold</div>
          <div className="text-2xl font-bold mb-1" data-id="element-1361">3,847</div>
          <div className="text-xs text-accent-success" data-id="element-1362">+12% vs LW</div>
        </Card>
        <Card className="p-4" data-id="element-1363">
          <div className="text-sm text-text-secondary mb-1" data-id="element-1364">Avg Margin</div>
          <div className="text-2xl font-bold mb-1" data-id="element-1365">71.5%</div>
          <div className="text-xs text-accent-success" data-id="element-1366">+2% vs LW</div>
        </Card>
        <Card className="p-4" data-id="element-1367">
          <div className="text-sm text-text-secondary mb-1" data-id="element-1368">Top Category</div>
          <div className="text-2xl font-bold mb-1" data-id="element-1369">🍔 Burgeri</div>
          <div className="text-xs text-text-secondary" data-id="element-1370">2.4M revenue</div>
        </Card>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1371">
        {/* Top Sellers */}
        <Card data-id="element-1372">
          <h3 className="font-bold mb-4 flex items-center gap-2" data-id="element-1373">
            <TrendingUp className="text-accent-success" size={20} data-id="element-1374" /> TOP SELLERS
          </h3>
          <div className="space-y-3" data-id="element-1375">
            {[{
            name: '1. BIG Double Smash',
            sold: '261 sold',
            trend: '⬆️ 12%'
          }, {
            name: '2. Supreme Triple',
            sold: '77 sold',
            trend: '⬆️ 8%'
          }, {
            name: '3. 2X Combo',
            sold: '58 sold',
            trend: '⬆️ 15%'
          }, {
            name: '4. DoubleCHEESE',
            sold: '80 sold',
            trend: '⬆️ 3%'
          }, {
            name: '5. Palačinka Nutela',
            sold: '40 sold',
            trend: '⬆️ 5%'
          }].map((item, i) => <div key={i} className="flex justify-between items-center p-2 hover:bg-white/5 rounded" data-id="element-1376">
                <span className="font-medium" data-id="element-1377">{item.name}</span>
                <div className="flex gap-4 text-sm" data-id="element-1378">
                  <span className="text-text-secondary" data-id="element-1379">{item.sold}</span>
                  <span className="text-accent-success font-bold w-12 text-right" data-id="element-1380">
                    {item.trend}
                  </span>
                </div>
              </div>)}
          </div>
        </Card>

        {/* Underperformers */}
        <Card data-id="element-1381">
          <h3 className="font-bold mb-4 flex items-center gap-2" data-id="element-1382">
            <TrendingDown className="text-accent-error" size={20} data-id="element-1383" />{' '}
            UNDERPERFORMERS
          </h3>
          <div className="space-y-3" data-id="element-1384">
            {[{
            name: 'Veggie Wrap',
            sold: '2 sold',
            trend: '⬇️'
          }, {
            name: 'Greek Salad',
            sold: '4 sold',
            trend: '⬇️'
          }, {
            name: 'Kids Meal',
            sold: '5 sold',
            trend: '⬇️'
          }, {
            name: 'Soup of Day',
            sold: '3 sold',
            trend: '⬇️'
          }, {
            name: 'Fruit Cup',
            sold: '1 sold',
            trend: '⬇️'
          }].map((item, i) => <div key={i} className="flex justify-between items-center p-2 hover:bg-white/5 rounded" data-id="element-1385">
                <span className="font-medium" data-id="element-1386">{item.name}</span>
                <div className="flex gap-4 text-sm" data-id="element-1387">
                  <span className="text-text-secondary" data-id="element-1388">{item.sold}</span>
                  <span className="text-accent-error font-bold w-6 text-right" data-id="element-1389">
                    {item.trend}
                  </span>
                </div>
              </div>)}
          </div>
        </Card>
      </div>

      {/* Category Breakdown */}
      <Card noPadding data-id="element-1390">
        <div className="p-4 border-b border-white/10 font-bold" data-id="element-1391">
          Category Breakdown
        </div>
        <div className="overflow-x-auto" data-id="element-1392">
          <table className="w-full text-sm" data-id="element-1393">
            <thead data-id="element-1394">
              <tr className="text-text-secondary border-b border-white/5" data-id="element-1395">
                <th className="text-left p-4" data-id="element-1396">CATEGORY</th>
                <th className="text-center p-4" data-id="element-1397">ITEMS SOLD</th>
                <th className="text-right p-4" data-id="element-1398">REVENUE</th>
                <th className="text-center p-4" data-id="element-1399">MARGIN</th>
                <th className="text-right p-4" data-id="element-1400">vs LAST WEEK</th>
              </tr>
            </thead>
            <tbody data-id="element-1401">
              {CATEGORY_STATS.map((cat, i) => <tr key={i} className="border-b border-white/5 hover:bg-white/5" data-id="element-1402">
                  <td className="p-4 font-bold" data-id="element-1403">{cat.name}</td>
                  <td className="p-4 text-center" data-id="element-1404">{cat.sold}</td>
                  <td className="p-4 text-right font-mono" data-id="element-1405">{cat.revenue}</td>
                  <td className="p-4 text-center" data-id="element-1406">
                    <div className="flex items-center justify-center gap-2" data-id="element-1407">
                      <span data-id="element-1408">{cat.margin}%</span>
                      {cat.warning && <AlertTriangle size={12} className="text-accent-warning" data-id="element-1409" />}
                    </div>
                  </td>
                  <td className={`p-4 text-right font-bold ${cat.trend.startsWith('+') ? 'text-accent-success' : 'text-accent-error'}`} data-id="element-1410">
                    {cat.trend.startsWith('+') ? '⬆️' : '⬇️'} {cat.trend}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>

      {/* Margin Analysis */}
      <Card className="p-6" data-id="element-1411">
        <h3 className="font-bold mb-6" data-id="element-1412">Margin Analysis</h3>
        <div className="space-y-4" data-id="element-1413">
          {CATEGORY_STATS.sort((a, b) => b.margin - a.margin).map((cat, i) => <div key={i} data-id="element-1414">
              <div className="flex justify-between text-sm mb-1" data-id="element-1415">
                <span className="font-medium" data-id="element-1416">{cat.name}</span>
                <span className={cat.margin < 70 ? 'text-accent-warning font-bold' : 'text-accent-success font-bold'} data-id="element-1417">
                  {cat.margin}% {cat.margin < 70 && '⚠️'}
                </span>
              </div>
              <div className="h-2 bg-white/10 rounded-full overflow-hidden" data-id="element-1418">
                <div className={`h-full rounded-full ${cat.margin < 70 ? 'bg-accent-warning' : 'bg-accent-success'}`} style={{
              width: `${cat.margin}%`
            }} data-id="element-1419"></div>
              </div>
            </div>)}
        </div>

        <div className="mt-6 p-4 bg-accent-warning/10 rounded-lg text-sm text-accent-warning space-y-1" data-id="element-1420">
          <div className="font-bold flex items-center gap-2" data-id="element-1421">
            <AlertTriangle size={16} data-id="element-1422" /> Margin Alerts:
          </div>
          <ul className="list-disc list-inside pl-1" data-id="element-1423">
            <li data-id="element-1424">Giros category below 70% target — review costs</li>
            <li data-id="element-1425">Drinks margin dropped 3% — check supplier pricing</li>
          </ul>
        </div>
      </Card>

      {/* AI Recommendations */}
      <Card className="p-6 border border-accent-primary/30 bg-accent-primary/5" data-id="element-1426">
        <h3 className="font-bold mb-4 flex items-center gap-2 text-accent-primary" data-id="element-1427">
          <Sparkles size={20} data-id="element-1428" /> AI RECOMMENDATIONS
        </h3>
        <ul className="space-y-3" data-id="element-1429">
          <li className="flex gap-3 items-start" data-id="element-1430">
            <span className="text-accent-primary mt-1" data-id="element-1431">•</span>
            <span data-id="element-1432">
              <span className="font-bold" data-id="element-1433">BIG Double Smash:</span> High demand,
              low price sensitivity → consider +50 RSD
            </span>
          </li>
          <li className="flex gap-3 items-start" data-id="element-1434">
            <span className="text-accent-primary mt-1" data-id="element-1435">•</span>
            <span data-id="element-1436">
              <span className="font-bold" data-id="element-1437">Veggie Wrap:</span> 2 sales in 7 days
              → consider removing or repositioning
            </span>
          </li>
          <li className="flex gap-3 items-start" data-id="element-1438">
            <span className="text-accent-primary mt-1" data-id="element-1439">•</span>
            <span data-id="element-1440">
              <span className="font-bold" data-id="element-1441">Palačinka Nutela:</span> Strong margin
              (80%) + steady demand → promote more
            </span>
          </li>
          <li className="flex gap-3 items-start" data-id="element-1442">
            <span className="text-accent-primary mt-1" data-id="element-1443">•</span>
            <span data-id="element-1444">
              <span className="font-bold" data-id="element-1445">Giros:</span> Margin below target →
              review meat supplier costs
            </span>
          </li>
          <li className="flex gap-3 items-start" data-id="element-1446">
            <span className="text-accent-primary mt-1" data-id="element-1447">•</span>
            <span data-id="element-1448">
              <span className="font-bold" data-id="element-1449">Late Night promo:</span> performing
              well → consider expanding hours
            </span>
          </li>
        </ul>
      </Card>
    </div>;
}